/**
 * Initialize Optional Fieldset handling.
 * @param {object} form 
 * @returns 
 */
const initOptionalFieldset = function(form) {
	const fieldsets = form.element.querySelectorAll('[data-fieldset-type][data-optional]');

	if (!fieldsets || fieldsets.length < 1) return;

	fieldsets.forEach(function(fieldset) {
		const checkbox = fieldset.querySelector('[type="checkbox"]');
		if (!checkbox) return;

		checkbox.addEventListener('change', function() {
			fieldset.disabled = !this.checked;
		});
	});
};

export default initOptionalFieldset;